import {
  ref,
  reactive,
  getCurrentInstance,
  onBeforeMount,
  watch,
  computed,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import quizListModel from "@/models/survey-quiz/quiz-list";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import useFlatPickr from "@/utils/hooks/useFlatPickr";

export default function useCreatePage(props) {
  const {
    fetchQuizDetailModel,
    createQuizInformation,
    updateQuestionModel,
    editQuizInformation,
  } = quizListModel();
  const vm = getCurrentInstance().proxy;

  const {
    openDefaultErrorModal,
    openErrorModal,
    openSuccessModal,
    openWarningModal,
  } = useValidationModal();

  const { resolveDate, resolveTime } = useFlatPickr();

  let seq = 1;
  let seqChoice = 1;

  const isEditData = ref(false);

  const loading = reactive({
    onsave: false,
  });

  const optionQuestion = reactive({
    typeChoiceOption: [
      { label: "Single Choice", value: 1, icon: "SingleChoiceSvg" },
    ],
    formatChoiceOption: [
      { label: "Text", value: 1 },
      { label: "Image", value: 2 },
      { label: "Text & Image", value: 3 },
    ],
  });

  let formQuestion = reactive([
    // {
    //   seqQuestion: 0,
    //   questionId: null,
    //   name: "Question",
    //   desc: "Description",
    //   image: { file: null, url: null },
    //   type: 1,
    //   format: 1,
    //   isShowImage: false,
    //   reason: "",
    //   dataChoice: [
    //     {
    //       seqChoice: 0,
    //       choiceId: null,
    //       choiceName: "choice",
    //       reason: "",
    //       isCorrect: false,
    //       imageChoice: { file: null, url: null },
    //     },
    //   ],
    // },
  ]);

  const formData = reactive({
    quizGroupId: 0,
    titleName: "",
    quizName: "",
    quizDesc: "",
    bannerImage: { file: null, url: null },
    displayImage: { file: null, url: null },
    status: false,
    validFrom: { date: null, time: null },
    validThrough: { date: null, time: null },
    settingAns: 1,
    isUploadImageQA: false,
    isHaspermission: false,
    permissionType: 1,
  });

  const nameNoHtml = computed(() => formData.quizName.replace(/<[^>]*>/g, ""));

  const descNoHtml = computed(() =>
    formData.quizDesc ? formData.quizDesc.replace(/<[^>]*>/g, "") : ""
  );

  const onUploadBanner = (image) => {
    formData.bannerImage.file = image.file;
    formData.bannerImage.url = image.url;
  };

  const onUploadDisplay = (image) => {
    formData.displayImage.file = image.file;
    formData.displayImage.url = image.url;
  };

  const onUploadImage = (image, formData) => {
    formData.image.file = image.file;
    formData.image.url = image.url;
  };

  const onShowUploadImage = (isShow) => {
    formQuestion.map((o) => {
      o.isShowImage = isShow;
    });
  };

  const onUploadImageChoice = (image, formData) => {
    formData.imageChoice.file = image.file;
    formData.imageChoice.url = image.url;
  };

  const addQuestion = () => {
    const maxSeq = formQuestion.reduce(
      (prev, current) =>
        prev.seqQuestion > current.seqQuestion ? prev : current,
      0
    );

    formQuestion.push({
      seqQuestion: maxSeq.seqQuestion ? maxSeq.seqQuestion + 1 : seq + 1,
      name: "",
      desc: "",
      image: { file: null, url: null },
      type: 1,
      format: 1,
      reason: "",
      isShowImage: false,
      dataChoice: [
        {
          seqChoice: seqChoice,
          choiceName: "",
          isCorrect: true,
          imageChoice: { file: null, url: null },
        },
      ],
    });
  };

  const onAddChoice = (question) => {
    question.dataChoice.map((o, index, { length }) => {
      if (index + 1 == length) {
        seqChoice = o.seqChoice || seqChoice;
      }
    });

    question.dataChoice.push({
      seqChoice: seqChoice + 1,
      choiceName: "",
      isCorrect: false,
      imageChoice: { file: null, url: null },
    });
  };

  const onRemoveChoice = (index, choice) => {
    choice.splice(index, 1);
  };

  const onRemoveQuestion = (index) => {
    formQuestion.splice(index, 1);
  };

  const onDuplicate = (formData, index, formDataBefore) => {
    const maxSeq = formQuestion.reduce(
      (prev, current) =>
        prev.seqQuestion > current.seqQuestion ? prev : current,
      0
    );

    let dataDuplicate = {
      seqQuestion: maxSeq.seqQuestion + 1,
      name: formData.name,
      desc: formData.desc,
      image: {
        file: formDataBefore[index].image.file,
        url: formData.image.url,
      },
      type: formData.type,
      format: formData.format,
      reason: formData.reason,
      isShowImage: formData.isShowImage,
      dataChoice:
        formData.dataChoice.length > 0
          ? formData.dataChoice.map((o, idx) => ({
              seqChoice: o.seqChoice,
              choiceId: o.choiceId,
              choiceName: o.choiceName,
              isCorrect: o.isCorrect,
              imageChoice: {
                file: formDataBefore[index].dataChoice[idx].imageChoice.file,
                url: o.imageChoice.url,
              },
            }))
          : [],
    };
    formQuestion.splice(index + 1, 0, dataDuplicate);
  };

  const nextStep = () => {
    window.scrollToTop();
    vm.$emit("onNextStep");
  };

  const createInformation = (payload) => {
    window.$loading(true);
    loading.onsave = true;
    createQuizInformation.payload = payload;
    return new Promise((resolve, reject) =>
      store
        .dispatch("api/apiFormRequest", createQuizInformation)
        .then((response) => {
          formData.quizGroupId = response.data.resp.quiz_groupid;
          router
            .replace(
              `${router.currentRoute.path}?quizGroupId=${formData.quizGroupId}`
            )

            .catch(() => {});
          resolve(formData.quizGroupId);
        })
        .catch((err) => {
          reject(err);
          openDefaultErrorModal(err);
          loading.onsave = false;
        })
        .finally(() => {})
    );
  };

  const updateQuestion = (groupId) => {
    loading.onsave = true;
    const payloadQuestion = {
      GroupId: groupId,
      Quiz_List:
        formQuestion.length > 0
          ? formQuestion.map((item) => ({
              QuizId: item.questionId,
              Seq_Quiz: item.seqQuestion,
              Qiuz_Name_HTML_Editor: item.name || "Question",
              Quiz_Desc_HTML_Editor: item.desc,
              Input_Type: item.format,
              Choice_Mode: item.type,
              Permission_Type: formData.permissionType,
              Quiz_Image_URL: item.image.file,
              Duplicate_Quiz_Image_URL: item.image.url,
              Option_List:
                item.dataChoice.length > 0
                  ? item.dataChoice.map((o) => ({
                      OptionId: o.choiceId,
                      Name: o.choiceName || "Choice",
                      Seq_Option: o.seqChoice,
                      Iscorrect: o.isCorrect,
                      Remark: item.reason,
                      Image: o.imageChoice.file,
                      Duplicate_Option_Image_URL: o.imageChoice.url,
                      score: 1,
                    }))
                  : [],
            }))
          : [],
    };

    updateQuestionModel.payload = payloadQuestion;

    store
      .dispatch("api/apiFormRequest", updateQuestionModel)
      .then((response) => {
        if (response.status === "success") {
          nextStep();
        }
      })
      .catch((err) => {
        openDefaultErrorModal(err);
        loading.onsave = false;
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const editInformation = (payload) => {
    window.$loading(true);
    loading.onsave = true;
    editQuizInformation.payload = payload;

    return new Promise((resolve, reject) => {
      store
        .dispatch("api/apiFormRequest", editQuizInformation)
        .then((response) => {
          const groupId = response.data.resp.quiz_groupid;
          resolve(groupId);
        })
        .catch((err) => {
          reject(err);
          openDefaultErrorModal(err);
          loading.onsave = false;
        })
        .finally(() => {});
    });
  };

  if (router.currentRoute.query.quizGroupId) {
    formData.quizGroupId = parseInt(router.currentRoute.query.quizGroupId);
  } else {
    formData.quizGroupId = parseInt(router.currentRoute.params.ref);
  }

  const fetchQuizDetail = () => {
    window.$loading(true);
    fetchQuizDetailModel.payload.GroupId = formData.quizGroupId;

    store
      .dispatch("api/apiFormRequest", fetchQuizDetailModel)
      .then((response) => {
        const respQuizGroup = response.data.resp.quiz_group;
        const respQuestion = response.data.resp.list_quiz;

        respQuestion.map((item) => {
          let remark = "";

          item.quiz_options.filter((o) => {
            if (o.quizid) {
              if (o.remark != null) {
                remark = o.remark;
              }
            }
          });

          if (item.quiz.seq)
            formQuestion.push({
              seqQuestion: item.quiz.seq,
              questionId: item.quiz.quizid,
              name: item.quiz.quiz_name_html_editor,
              desc: item.quiz.quiz_desc_html_editor,
              image: { url: item.quiz.quiz_image_url },
              type: item.quiz.choice_mode,
              format: item.quiz.input_type,
              reason: remark,
              dataChoice: [],
            });

          let formData = [];
          formQuestion.map((question) => {
            formData = question.dataChoice;
          });

          if (item.quiz_options) {
            item.quiz_options.map((choice) => {
              formData.push({
                seqChoice: choice.seq,
                choiceId: choice.optionid,
                choiceName: choice.name,
                isCorrect: choice.iscorrect,
                imageChoice: {
                  url: choice.option_image_url,
                },
              });
            });
          }
        });

        formData.quizGroupId = respQuizGroup.quiz_groupid;
        formData.titleName = respQuizGroup.title_name;
        formData.quizName = respQuizGroup.quiz_name_html_editor;
        formData.quizDesc = respQuizGroup.description_html_editor;
        formData.bannerImage.url = respQuizGroup.cover_image_url;
        formData.displayImage.url = respQuizGroup.display_image_url;
        formData.status = respQuizGroup.status == 1;
        formData.validFrom.date = resolveDate(respQuizGroup.valid_from);
        formData.validFrom.time = resolveTime(respQuizGroup.valid_from);
        formData.validThrough.date = resolveDate(respQuizGroup.valid_through);
        formData.validThrough.time = resolveTime(respQuizGroup.valid_through);
        formData.settingAns = respQuizGroup.reply_type;
        formData.isHaspermission = response.data.resp.is_haspermission;
        formData.permissionType = respQuizGroup.permission_type;

        vm.$emit("onSetTitleName", formData.titleName);
        vm.$emit("isHaspermission", formData.isHaspermission);
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {
        window.$loading(false);
        isEditData.value = false;
      });
  };

  const resolveDateFormat = (dateStr) => {
    if (!dateStr) return;
    const dateSplit = dateStr.split("-");
    const date = dateSplit[0];
    const month = dateSplit[1];
    const year = dateSplit[2];

    return `${year}-${month}-${date}`;
  };

  const submitForm = async () => {
    const payload = {
      GroupId: formData.quizGroupId,
      Title_Name: props.formDataInfo.titleName,
      Quiz_Name: formData.quizName,
      Desc: formData.quizDesc,
      Function_Type: 1,
      Permission_Type: 1,
      Cover_ImageURL: formData.bannerImage.file,
      Display_ImageURL: formData.displayImage.file,
      IsLimit: 0,
      Limit: "",
      Status: formData.status == true ? 1 : 2,
      Reply_Type: formData.settingAns,
      Valid_From:
        formData.validFrom.date && formData.validFrom.time
          ? `${resolveDateFormat(formData.validFrom.date)} ${
              formData.validFrom.time
            }`
          : null,
      Valid_Through:
        formData.validThrough.date && formData.validThrough.time
          ? `${resolveDateFormat(formData.validThrough.date)} ${
              formData.validThrough.time
            }`
          : null,
    };

    if (quizId || props.isEdit) {
      editInformation(payload).then((value) => {
        updateQuestion(value);
      });
    } else {
      delete payload.GroupId;
      createInformation(payload).then((value) => {
        updateQuestion(value);
      });
    }
  };

  const openWarningSaveData = () => {
    openWarningModal(
      "ต้องการบันทึกการเปลี่ยนแปลงหรือไม่",
      null,
      () => {
        submitForm();
      },
      () => {
        router.push("/quiz/quiz-list").catch(() => {});
      }
    );
  };

  const onBack = () => {
    if (props.isEdit) {
      if (isEditData.value == true) {
        openWarningSaveData();
      } else {
        router.push("/quiz/quiz-list").catch(() => {});
      }
    } else {
      router.push("/quiz/quiz-list").catch(() => {});
    }
  };

  const resolveDateNow = (dateInput) => {
    const date = new Date(dateInput);

    try {
      const dateStr = `${date.toLocaleString("default", {
        day: "2-digit",
      })}-${date.toLocaleString("default", {
        month: "2-digit",
      })}-${date.getFullYear()}`;

      return dateStr;
    } catch (err) {
      return "";
    }
  };

  const resolveTimeNow = (timeInput) => {
    const time = new Date(timeInput);

    try {
      const hours = time.getHours();
      const minutes = time.getMinutes();
      const seconds = time.getSeconds();

      const timeStr = `${hours < 10 ? `0${hours}` : hours}:${
        minutes < 10 ? `0${minutes}` : minutes
      }:${seconds < 10 ? `0${seconds}` : seconds}`;

      return timeStr;
    } catch (err) {
      return "";
    }
  };

  var quizCreateTime = new Date().toJSON();

  const validFormDisable = computed(() => {
    return (
      !nameNoHtml ||
      !formData.bannerImage.url ||
      !formData.displayImage.url ||
      !formData.validFrom.date ||
      !formData.validFrom.time ||
      !formData.validThrough.date ||
      !formData.validThrough.time
    );
  });

  watch(
    formData,
    () => {
      isEditData.value = true;
    },
    { deep: true }
  );

  let quizId = parseInt(router.currentRoute.query.quizGroupId);

  onBeforeMount(() => {
    if (quizId) {
      fetchQuizDetail();
    }
    if (props.isEdit) {
      fetchQuizDetail();
    } else {
      if (!quizId) {
        formData.titleName =
          "Survey" +
          " " +
          resolveDateNow(quizCreateTime) +
          " " +
          resolveTimeNow(quizCreateTime);
        vm.$emit("onSetTitleName", formData.titleName);

        return formQuestion.push({
          questionId: 0,
          seqQuestion: 1,
          name: "Question",
          desc: "",
          image: { file: null, url: null },
          type: 1,
          format: 1,
          reason: "",
          isShowImage: false,
          dataChoice: [
            {
              choiceId: 0,
              choiceName: "Choice",
              isCorrect: true,
              imageChoice: { file: null, url: null },
            },
          ],
        });
      }
    }
  });

  return {
    addQuestion,
    formQuestion,
    onAddChoice,
    optionQuestion,
    submitForm,
    formData,
    onUploadBanner,
    onUploadDisplay,
    onUploadImage,
    onShowUploadImage,
    onUploadImageChoice,
    onRemoveChoice,
    onRemoveQuestion,
    onDuplicate,
    nextStep,
    fetchQuizDetail,
    onBack,
    nameNoHtml,
    descNoHtml,
    validFormDisable,
    loading,
  };
}
